import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import PersonIcon from '@mui/icons-material/Person';
import { Link, Outlet } from 'react-router-dom';
import TopBar from './TopBar';

export default function Main() {
  const [value, setValue] = React.useState(0);
  const [user, setUser] = React.useState(JSON.parse(localStorage.getItem("signin-data")).usuario);

  React.useEffect(() => {
    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);
    setUser(data.usuario)
  }, [value]);

  return (
    <Box>
      <TopBar/>
      <CssBaseline />
      <Outlet/>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          variant="default"
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          
          <BottomNavigationAction component={Link} to={'/main/home'} value={'/main/home'}  label="Home" icon={<HomeIcon />} />
          <BottomNavigationAction component={Link} to={'/main/challenges'} value={'/main/challenges'} label="Retos" icon={<NotificationsIcon />} />
          <BottomNavigationAction component={Link} to={'/main/rewards'} value={'/main/rewards'} label="Rewards" icon={<SpaceDashboardIcon />} />
          <BottomNavigationAction component={Link} to={'/main/profile'} value={'/main/profile'} label="Profile" icon={<PersonIcon />} />
        </BottomNavigation>
      </Paper>
    </Box>
  );
}